export type CommerceAction = "order" | "tap" | "collect";

// Same commerce glyphs as api/liquidcard_assets/liquidcard.js in production.
export function HandleCommerceIcon({ action }: { action: CommerceAction }) {
  return <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {action === "order" && <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8" /></>}
    {action === "tap" && <><circle cx="12" cy="12" r="9" /><path d="M12 5v14M15 8h-4a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9" /></>}
    {action === "collect" && <><path d="M2 4h12v13H2zM14 9h4l4 5v3h-8" /><circle cx="6" cy="18" r="2" /><circle cx="18" cy="18" r="2" /></>}
  </svg>;
}

export function HandlePasskeyIcon() {
  return <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3M8 8v2M16 8v2M12 8v5h-1M8 16q4 3 8 0" /></svg>;
}
